module.exports = __webpack_public_path__ + "static/media/schody11 - schody drewniane zabiegowe nakladane.35543cb1.jpg";